import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AmbassadorAuthRequest, AmbassadorService, AvailableAmbassador } from 'remarketing-angular-library';

import { ModalComponent } from 'remarketing-ui-components-lib';
import { take } from 'rxjs/operators';

import { TranslocoDirective } from '@jsverse/transloco';


@Component({
    selector: 'app-authorize-ambassadors-modal',
    templateUrl: './authorize-ambassadors-modal.component.html',
    styleUrls: ['./authorize-ambassadors-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent]
})
export class AuthorizeAmbassadorsModalComponent {
  @Input() modalId: string;
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Output() ambassadors = new EventEmitter();
  @Output() success = new EventEmitter<string>();
  @Output() error = new EventEmitter();
  public variant: string;
  public ambassador: AvailableAmbassador;
  public ambassadorAuthReq: AmbassadorAuthRequest;

  constructor(
    private readonly ambassadorService: AmbassadorService
  ) {}

  show(ambassadorAuthReq: AmbassadorAuthRequest, ambassador: AvailableAmbassador) {
    this.ambassador = ambassador;
    this.ambassadorAuthReq = ambassadorAuthReq;
    this.modal.show();
  }

  close() {
    this.modal.close();
  }

  submit() {
    this.ambassadorService.authorizeAmbassador(this.ambassadorAuthReq).pipe(take(1)).subscribe((response: any) =>
    {
      if (response && response.ambassadors) {
        this.ambassadors.emit(response.ambassadors);
        this.modal.close();
        this.success.emit(this.ambassador.name);
      }
    },
    () => {
      this.modal.close();
      this.error.emit();
    }
    );
  }

  reformatPhone(phone: string): string {
    if (phone) {
      phone = phone.replace(/-/g, '');
      if (phone.length > 0) {
        if (phone.length === 11) {
          phone = `(${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7)}`;
          return phone;
        } else {
          phone = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
          return phone;
        }
      }
    }

    return undefined;
  }
}
